import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import GuestBookPage from "./pages/GuestBook/GuestBook";
import Layout from "./pages/Layout";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<GuestBookPage />} />
          <Route path="guestbook" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
